module.exports = __webpack_public_path__ + "img/Terms.6dd47c90.svg";